import { MatDialogConfig } from '@angular/material/dialog';

export const DIALOG_PANEL_DEFAULT_CONFIG = { panelClass: ['new-design'] } as MatDialogConfig;

export interface GenericDialogData {
	title: string;
	content: string;
}

export abstract class PreventDialogCloseOnNavigation {
	preventCloseOnNavigation = true;
}
